export enum BadgeVariantEnum {
  YELLOW = 'yellow',
  GREY_LIGHT = 'grey-light',
  BORDER_GREY = 'border-grey',
  BORDER_ORANGE = 'border-orange',
}
